export const TRANSLATION_KEYS = {
	QUIZ: 'onboarding-quiz',
};
